import app from '../app.first';
import $ from 'jquery';

app.RecruiterDashboard = class extends app.Component {
	onReady() {
		if ($('#register_modal').length > 0) {
			$('#membership-model').parent().parent().addClass('second-option');

			$('#placement-model').click(function() {
				$('#membership-model').prop('checked', false);
			});

			$('#membership-model').click(function() {
				$('#placement-model').prop('checked', false);
			});

			$('#register_modal').foundation('open');
		}

		$('#job_salary').parent().append('<span id="job_salary_value"></span>');

		if ($('#job_salary_value').length) {
			//  // [MYC-197] @SABUILD 
			$('#job_salary_value').text('C$' + $('#job_salary').val().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));

		}

		$('#job_salary').on('input', function() {
			//  // [MYC-197] @SABUILD 
			$('#job_salary_value').text('C$' + $('#job_salary').val().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
		})
		this.initPikaday();

		if ($(".redactor").length) {
			$('.redactor').redactor({
				plugins: ['source'],
				minHeight: '200px',
				callbacks: {
					uploadBeforeSend: xhr => {
						let token = Cookies.get('csrfToken');
						if (token) {
							xhr.setRequestHeader('X-CSRF-Token', token);
						}
					}
				}
			});
		}
	}

	initPikaday() {
		this.$el.find('.pika-day').each((index, element) => {
			let field_type = $(element).prop('autocomplete', 'off').data("field-type");
			let data_date = $(element).prop('autocomplete', 'off').data("date");
			let date_lower = new Date();
			let date_upper = new Date();
			date_upper.setDate(date_upper.getDate() + 30)
			let show_time = false;
			let date_format = 'YYYY-MM-DD';
			let min_date = '';
			let max_date = '';

			if (field_type == 'datetime') {
				show_time = true;
				date_format = 'YYYY-MM-DD HH:mm';
			}
			if (data_date == 'closing_date') {
				min_date = date_lower;
				max_date = date_upper;
			}

			new Pikaday({
				field: element,
				format: date_format,
				use24hour: false,
				showTime: show_time,
				minDate: min_date,
				maxDate: max_date
			});
		});
	}
}